import HomePageHelper from 'components/home-page/home-page-helper';

class PopularContentsHelper extends HomePageHelper {

    constructor() {
        super();
    }

    /**
     * Returns an array of content keys that match the current category from the recommendations response.
     * @param currentCategory
     * @param data
     * @returns {Array}
     */
    getDisplayDataKeys(currentCategory, data) {
        const displayData = data.categories[currentCategory];
        const displayDataKeys = [];
        (displayData || []).forEach(item => { (item.contentKey) ? displayDataKeys.push(item.contentKey) : null; });

        return displayDataKeys;
    }

    /**
     * Check if the current category is a key in the recommendation response.
     * @param currentCategory
     * @param data
     * @returns {*|boolean}
     */
    static isCurrentPopularCategoryInData(currentCategory, data) {
        return (data && data.popularContents && data.popularContents.categories && (currentCategory in data.popularContents.categories));
    }

    /**
     * Check's if content is in the same category as obtained from the recommendation service.
     * @param currentCategory
     * @param content
     * @returns {boolean|*}
     */
    isContentInSameDisplayCategory(currentCategory, content) {
        return ((currentCategory === this.defaultCategory) || (currentCategory && content && content.category && (currentCategory === content.category)));
    }

    /**
     * Check if the content is a public content before rendering the content card
     * @param content
     */
    shouldDisplayContent(content) {
        let displayContent = false;
        const contentShareStatus = (content && content.shareStatus && (content.shareStatus === 'PUBLIC'));
        const contentPublicallyIndexable = (content && content.hasOwnProperty('isPubliclyIndexable')) ? content.isPubliclyIndexable : true;
        const contentHasRequiredData = (content && content.channelTitle && content.channelKey && content.title && content.id);

        if (contentShareStatus && contentPublicallyIndexable && contentHasRequiredData) {
            displayContent = true;
        }

        return displayContent;
    }
    /**
     * Check if the page could load more contents
     * @returns {boolean}
     */
    canLoadMore(pageNumber, lastPageNumbersForCategories) {
        return pageNumber < lastPageNumbersForCategories;
    }

    contentsToTrimPerScreenSize(numberOfContents) {
        const contentCardContainerArray = document.getElementsByClassName('content-card-container');
        if (!contentCardContainerArray || !(contentCardContainerArray.length >= 1)) {
            return 0;
        }

        const width = contentCardContainerArray[0].offsetWidth;

        switch (true) {
        case width >= 1860:
            return numberOfContents % 6;
        case width >= 1550:
            return numberOfContents % 5;
        case width >= 1240:
            return numberOfContents % 4;
        case width >= 915:
            return numberOfContents % 3;
        case width >= 461:
            return numberOfContents % 2;
        default:
            return 0;
        }
    }

    trimContentsByScreenSize(contentArray) {
        // If contentsToSpliceOut returns 2, this removes the last 2 elements from the contentArray
        const contentsToSpliceOut = this.contentsToTrimPerScreenSize(contentArray.length);
        if (contentsToSpliceOut && contentArray.length > contentsToSpliceOut) {
            contentArray.splice(-contentsToSpliceOut);
        }
        return contentArray;
    }
}

export default PopularContentsHelper;



// WEBPACK FOOTER //
// ./src/components/home-page/popular/popular-content-helper.js